import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NavbarComponent } from '../_shared/components/navbar/navbar.component';
import { SidebarComponent } from './_shared/components/sidebar/sidebar.component';

@Component({
  selector: 'app-fuel-management',
  standalone: true,
  imports: [RouterModule, NavbarComponent, SidebarComponent],
  templateUrl: './fuel-management.component.html',
  styleUrl: './fuel-management.component.scss'
})
export class FuelManagementComponent implements OnDestroy {
  @Input() isCollapsed: boolean = false;
  @Input() opneSidebar: boolean = false;
  @Output() toggleCollapse = new EventEmitter<void>();
  @Input() closeSidebar!: () => void;

  private readonly compactQuery = window.matchMedia('(max-width: 1180px)');
  isCompact = this.compactQuery.matches;
  isAnimating = false;
  private animationTimeoutId?: ReturnType<typeof setTimeout>;

  private readonly onCompactChange = (event: MediaQueryListEvent): void => {
    this.isCompact = event.matches;
  };

  constructor() {
    this.compactQuery.addEventListener('change', this.onCompactChange);
  }

  ngOnDestroy(): void {
    this.compactQuery.removeEventListener('change', this.onCompactChange);
    clearTimeout(this.animationTimeoutId);
  }

  onToggleCollapse(): void {
    this.isAnimating = true;
    this.isCollapsed = !this.isCollapsed;

    clearTimeout(this.animationTimeoutId);
    this.animationTimeoutId = setTimeout(() => this.isAnimating = false, 300);
  }
  sidebarToggle(): void {
    this.opneSidebar = !this.opneSidebar;
  }
  sidebarToggleClose(): void {
    this.opneSidebar = false;
  }
}
